import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import registerServiceWorker from "./registerServiceWorker";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import AuthenticationReducer from "./ReduxStore/Reducers/AuthenticationReducer";
import TicketReducer from "./ReduxStore/Reducers/TicketReducer";
import SportEventReducer from "./ReduxStore/Reducers/SportEventReducer";
import NavigationReducer from "./ReduxStore/Reducers/NavigationReducer";
import BalanceReducer from "./ReduxStore/Reducers/BalanceReducer";
import AppStateReducer from "./ReduxStore/Reducers/AppStateReducer";
import { createStore, applyMiddleware, compose, combineReducers } from "redux";
import thunk from "redux-thunk";

//const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const composeEnhancers =
  (window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ &&
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
      trace: true,
      traceLimit: 25
    })) ||
  compose;
const rootReducer = combineReducers({
  rrAuthentication: AuthenticationReducer,
  rrTicket: TicketReducer,
  rrSportEvent: SportEventReducer,
  rrNavigation: NavigationReducer,
  rrBalance: BalanceReducer,
  rrAppState: AppStateReducer
});

const store = createStore(
  rootReducer,
  composeEnhancers(applyMiddleware(thunk))
);

const app = (
  <Provider store={store}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </Provider>
);

ReactDOM.render(app, document.getElementById("root"));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js